import { pushURL, type PickUrlContext } from '@/views/reports/pickers/base/utils';
import { pushURL as pushURLConversions } from '@/views/reports/pickers/base/conversions/utils';
import { pushURL as pushURLPostbacks } from '@/views/reports/pickers/base/postbacks/utils';
import { pushURL as pushURLErrors } from '@/views/reports/pickers/base/errors/utils';
import { pushURL as pushURLLiveVisits } from '@/views/reports/pickers/base/live-visits/utils';
import { pushURL as pushURLLiveClicks } from '@/views/reports/pickers/base/live-clicks/utils';
import {
  isDedicatedReportRoute,
} from '@/views/reports/report-route-behavior';

const dedicatedPushUrlHandlers: Record<string, (context: PickUrlContext, callback?: () => void) => unknown> = {
  'app.conversions': pushURLConversions,
  'app.postbacks': pushURLPostbacks,
  'app.errors': pushURLErrors,
  'app.live-visits': pushURLLiveVisits,
  'app.live-clicks': pushURLLiveClicks,
};

export const getDedicatedPushUrlHandler = (
  routeName: string | symbol | null | undefined,
) => {
  if (typeof routeName !== 'string' || !isDedicatedReportRoute(routeName)) {
    return null;
  }

  return dedicatedPushUrlHandlers[routeName];
};

export const pushReportUrl = (
  routeName: string | symbol | null | undefined,
  context: PickUrlContext,
) => {
  const pushUrlHandler = getDedicatedPushUrlHandler(routeName);

  if (pushUrlHandler) {
    return pushUrlHandler(context);
  }

  return pushURL(context);
};
